import React, { useEffect, useState } from "react";
import {  Row, Col, Card } from "react-bootstrap";
import "./ShoppingcardPage.css";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import product_default from "../../../assets/product_default.png";
import emptycartimg from "./../../../assets/emptycart.svg";
import { toast } from "react-toastify";
import { maintainCartdata } from "../../home/redux/actions";
import { useTranslation } from "react-i18next";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { LazyLoadImage } from "react-lazy-load-image-component";
import arrowback from "../../../assets/arrow_back.svg";
import { MINUS, PLUS_ADD } from "../../comman/components/CommonimagePath";
import { getRequestcall } from "../../comman/util/getRequest";
import {
  ADD_PRODUCT_CART,
  CART_DETAIL,
  CART_ITEM_DELETE,
} from "../../constants/apiurl";
import { postRequestcall } from "../../comman/util/postRequest";
import BannercartPage from "../../comman/components/BannercartPage";
import { OrdersummaryPage } from "../../comman/components/CurrentorderlistPage";
import ButtonPage from "../../comman/button/ButtonPage";
const SelectdeliveryPage = React.lazy(() => import("./SelectdeliveryPage"));
const CoupanPage = React.lazy(() =>
  import("../../modal/components/CoupanPage")
);

function ShoppingcardPage(props) {
  
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showcoupon, setShowcoupon] = useState(false);
  const [cartlist, setCartlist] = useState([]);
  const [emptycart, setEmptycart] = useState(false);
  const [showdelivery, setShowdelivery] = useState(false);
  const [storelocation, setStorelocation] = useState({
    store_lat: "",
    store_lng: "",
    store_address:""
  });

  // eslint-disable-next-line
  useEffect(() => {
    (async () => cartDetail())();
    // eslint-disable-next-line
  }, []);

  const cartDetail = async () => {
    props?.fetchHeaderContent(t("pages.meta.cart.title"), t("pages.meta.cart.description"), "");
    if (props.access_token) {
      let getCartdetailapiresponse = await getRequestcall(
        CART_DETAIL+ `?lang=${props?.language?.toLowerCase()}`,
        props?.access_token,
      );
      if (getCartdetailapiresponse?.status === 200) {
        let getRes = await getCartdetailapiresponse.json();
        if (getRes?.data?.cart_products?.length > 0) {
          setEmptycart(false);
          setStorelocation({
            store_lat: getRes?.data?.store_lat,
            store_lng: getRes?.data?.store_lng,
            store_address: getRes?.data?.store_address
          });
          setCartlist(getRes?.data?.cart_products);
          vatRateafterlogin(getRes);
        } else {
          emptyCart();
        }
      } else if (getCartdetailapiresponse?.status === 400) {
        let getError = await getCartdetailapiresponse.json();
        toast.error(getError?.errors);
        emptyCart();
      }  
      else if (getCartdetailapiresponse?.status === 401) {
        navigate("/", { state: { autologout: true } });
      }
    } else {
      getProductlistbeforelogin(); // Before login get the data from redux
    }
  };

  const vatRateafterlogin = (getRes) => {
    let total_amount = 0;
    let final_vat_rate = 0;
    let final_sub_total = 0;
    getRes?.data?.cart_products?.forEach((item) => {
      if (
        item?.product_deleted_at === null &&
        item?.out_of_stock === false &&
        item.variation_deleted_at === null
      ) {
        let productPrice = 0;
        let vat_rate = 0;
        let sub_total = 0;
        if (
          item?.discount !== null &&
          item?.discount !== 0 &&
          item?.discount < item?.price
        ) {
          productPrice = item?.discount * item.quantity;
        } else {
          productPrice = item?.price * item.quantity;
        }
        if (typeof item.vatrate === "undefined" || item.vatrate === null) {
          sub_total = productPrice;
        } else {
          sub_total = productPrice / (item?.vatrate / 100 + 1);
          vat_rate = productPrice - sub_total;
          final_vat_rate = final_vat_rate + vat_rate;
        }
        final_sub_total = final_sub_total + sub_total;
        total_amount = total_amount + productPrice;
      }
    });
    let amount = {
      ...props.amount,
      sub_total: final_sub_total.toFixed(2),
      vat_rate: final_vat_rate.toFixed(2),
      total_amount: total_amount,
    };
    props.maintainCartdata(getRes?.data?.cart_products, amount); // store in redux for checkout and payment detail page
  };

  const emptyCart = () => {
    props.maintainCartdata([], {});
    setCartlist([]);
    setEmptycart(true);
  };

  const getProductlistbeforelogin = () => {
    let productlist = [];
    let total_amount = 0;
    let final_vat_rate = 0;
    let final_sub_total = 0;
    if (props?.cartdata?.length === 0) {
      emptyCart();
    } else {
      props?.cartdata?.forEach((product) => {
        let productPrice = 0;
        let vat_rate = 0;
        let sub_total = 0;
        productlist.push(product);
        if (
          product?.discount !== null &&
          product?.discount !== 0 &&
          product?.discount < product?.price
        ) {
          productPrice = product?.discount * product?.quantity;
        } else {
          productPrice = product?.price * product?.quantity;
        }
        if (
          typeof product.vatrate === "undefined" ||
          product.vatrate === null
        ) {
          sub_total = productPrice;
        } else {
          sub_total = productPrice / (product.vatrate / 100 + 1);
          vat_rate = productPrice - sub_total;
          final_vat_rate = final_vat_rate + vat_rate;
        }
        final_sub_total = final_sub_total + sub_total;
        total_amount = total_amount + productPrice;
      });
      setCartlist(productlist);
      let amount = {
        ...props.amount,
        sub_total: final_sub_total.toFixed(2),
        vat_rate: final_vat_rate.toFixed(2),
        total_amount: total_amount,
      };
      props.maintainCartdata(props?.cartdata, amount);
    }
  };

  const quantityMinus = async (variation_id) => {
    let getResponse;
    let updated_id;
    let filterCartlist = cartlist.filter(
      (item) => item.variation_id === variation_id
    );
    if (filterCartlist.length > 0) {
      if (props.access_token) {
        if (filterCartlist[0]?.quantity === 1) {
          let geturl = CART_ITEM_DELETE + `?id=${filterCartlist[0]?.id}`;
          getResponse = await postRequestcall(geturl, props?.access_token, "");
        } else {
          let geturl =
            ADD_PRODUCT_CART +
            `?store_id=${filterCartlist[0]?.store_id}&product_id=${
              filterCartlist[0]?.product_id
            }&variation_id=${filterCartlist[0]?.variation_id}&quantity=${
              filterCartlist[0]?.quantity - 1
            }&id=${filterCartlist[0]?.id}`;
          getResponse = await postRequestcall(geturl, props?.access_token, "");
        }
        if (getResponse?.status === 200) {
          if (filterCartlist[0]?.quantity === 1) {
            filterShoppingcart(variation_id, "", null);
          } else {
            let id = await getResponse.json();
            updated_id = id.data;
            filterShoppingcart(
              variation_id,
              updated_id,
              filterCartlist[0].quantity - 1
            );
          }
        }
      } else {
        filterShoppingcart(
          variation_id,
          "",
          filterCartlist[0]?.quantity === 1
            ? null
            : filterCartlist[0].quantity - 1
        );
      }
    }
  };

  const quantityPlus = async (variation_id) => {
    let check_stock = true;
    let updated_id;
    let filterCartlist = cartlist.filter(
      (item) => item.variation_id === variation_id
    );
    if (filterCartlist.length > 0) {
      if (filterCartlist[0]?.is_stock === "yes") {
        if (filterCartlist[0].quantity + 1 > filterCartlist[0]?.stock) {
          check_stock = false;
          toast.error(t('pages.Out of Stock'))
          // toast.error(
          //   t("pages.You can not add more than") +
          //     " " +
          //     filterCartlist[0]?.stock +
          //     " " +
          //     t("pages.quantities of this product")
          // );
        }
      } else {
        check_stock = true;
      }
      if (check_stock === true) {
        if (props.access_token) {
          let geturl =
            ADD_PRODUCT_CART +
            `?store_id=${filterCartlist[0]?.store_id}&product_id=${
              filterCartlist[0]?.product_id
            }&variation_id=${filterCartlist[0]?.variation_id}&quantity=${
              filterCartlist[0]?.quantity + 1
            }&id=${filterCartlist[0]?.id}`;
          let getCartapiresponse = await postRequestcall(
            geturl,
            props?.access_token,
            ""
          );
          if (getCartapiresponse?.status === 200) {
            let id = await getCartapiresponse.json();
            updated_id = id.data;
            filterShoppingcart(
              variation_id,
              updated_id,
              filterCartlist[0].quantity + 1
            );
          }
        } else {
          filterShoppingcart(variation_id, "", filterCartlist[0].quantity + 1);
        }
      }
    }
  };

  const filterShoppingcart = (variation_id, id, quantity) => {
    // Update cart with index
    let productlist = [];
    let total_amount = 0;
    let final_vat_rate = 0;
    let final_sub_total = 0;
    cartlist.forEach((item, index) => {
      let productPrice = 0;
      let vat_rate = 0;
      let sub_total = 0;
      if (item.variation_id === variation_id) {
        let cart_detail = quantity === null ? null : { id, quantity };
        cartlist[index].quantity = quantity;
        cartlist[index].cart_detail = cart_detail;
        productlist.push(cartlist[index]);
      } else {
        productlist.push(cartlist[index]);
      }
      if (cartlist[index].cart_detail !== null) {
        if (
          cartlist[index]?.discount !== null &&
          cartlist[index]?.discount !== 0 &&
          cartlist[index]?.discount < cartlist[index]?.price
        ) {
          productPrice = cartlist[index]?.discount * cartlist[index]?.quantity;
        } else {
          productPrice = cartlist[index]?.price * cartlist[index]?.quantity;
        }
        if (typeof item.vatrate === "undefined" || item.vatrate === null) {
          sub_total = productPrice;
        } else {
          sub_total = productPrice / (item.vatrate / 100 + 1);
          vat_rate = productPrice - sub_total;
          final_vat_rate = final_vat_rate + vat_rate;
        }
        final_sub_total = final_sub_total + sub_total;
        total_amount = total_amount + productPrice;
      }
    });
    let updatedList = productlist.filter((item) => item.cart_detail !== null);
    if (updatedList.length !== 0) {
      setCartlist(updatedList);
      // Developer comment :: If user apply coupon or delivery charges and after that if user add product or minus product then the discount and charges will be zero
      let amount = {
        ...props.amount,
        sub_total: final_sub_total.toFixed(2),
        vat_rate: final_vat_rate.toFixed(2),
        total_amount: total_amount,
        discount: 0,
        charges: 0,
        coupon_code: "",
        offer_id: "",
      };
      props.maintainCartdata(updatedList, amount); // update to redux
    } else {
      emptyCart();
    }
  };

  const removeProduct = async (variation_id) => {
    let getResponse;
    let filterCartlist = cartlist.filter(
      (item) => item.variation_id === variation_id
    );
    if (filterCartlist.length > 0) {
      if (props.access_token) {
        let geturl = CART_ITEM_DELETE + `?id=${filterCartlist[0]?.id}`;
        getResponse = await postRequestcall(geturl, props?.access_token, "");
        if (getResponse?.status === 200) {
          let filterCartlist = cartlist.filter(
            (item) => item.variation_id !== variation_id
          );
          if (filterCartlist.length === 0) {
            emptyCart();
          } else {
            filterShoppingcart(variation_id, "", null);
            //setCartlist(filterCartlist);
          }
        }
      } else {
        let filterCartlist = cartlist.filter(
          (item) => item.variation_id !== variation_id
        );
        if (filterCartlist.length === 0) {
          emptyCart();
        } else {
          filterShoppingcart(variation_id, "", null);
          //setCartlist(filterCartlist);
        }
      }
    }
  };

  const navigateTocheckout = async (e) => {
    e.preventDefault();
    let getCartdetailapiresponse = await getRequestcall(
      CART_DETAIL+ `?lang=${props?.language?.toLowerCase()}`,
      props?.access_token,
    );
    if (getCartdetailapiresponse?.status === 200) {
      let getRes = await getCartdetailapiresponse.json();
      const OutOfStock = getRes?.data?.cart_products?.filter((item)=>item?.out_of_stock !== false)
      if(OutOfStock?.length === 0 && getRes?.data?.cart_products?.length>0){
        if (props?.amount?.total_amount === 0) {
          toast.error(t("pages.Please add product to cart"));
        } else {
          if (cartlist.length === 0) {
            toast.error(t("pages.Your shopping bag is empty"));
          } else {
            setShowdelivery(true);
          }
        }
      }else{
        if (getRes?.data?.cart_products?.length > 0) {
          setEmptycart(false);
          setStorelocation({
            store_lat: getRes?.data?.store_lat,
            store_lng: getRes?.data?.store_lng,
            store_address: getRes?.data?.store_address
          });
          setCartlist(getRes?.data?.cart_products);
          vatRateafterlogin(getRes);
        } else {
          emptyCart();
        }
      }
    } else if (getCartdetailapiresponse?.status === 400) {
      let getError = await getCartdetailapiresponse.json();
      toast.error(getError?.errors);
      emptyCart();
    }  

  };

  const openCouponpage = () => {
    if (props.access_token) {
      setShowcoupon(true);
    } else {
      toast.error(t("pages.Please login first"));
    }
  };

  const quantityBox = (item) => {
      return (
        item?.variation_deleted_at === null &&
          item?.product_deleted_at === null ? (
            item?.out_of_stock === false ? (
              <div className="qty-action">
                <ButtonPage
                    Text={<img src={MINUS} height="18" width="18" alt="minus" />}
                    onClick={() => quantityMinus(item?.variation_id)}
                    className="button-minus"
                    type={"button"}
                />
                <span className="qty">{item?.quantity}</span>
                <ButtonPage
                    Text={<img src={PLUS_ADD} height="18" width="18" alt="plus" />}
                    onClick={() => quantityPlus(item?.variation_id)}
                    className="button-minus"
                    type={"button"}
                />
              </div>
            ) : (
              <h5 className="not-product">
                {t("pages.Out of Stock")}
              </h5>
            )
          ) : (
            <h5 className="not-product">
              {t("pages.Not available")}
            </h5>
          )
      )
  }

  return (
    <aside className="shop-card">
      <BannercartPage title={"pages.card.title"}/>
      <div className="container main-shopcard py-5">
        <div className="row">
          <div className="col-xl-9">
            {emptycart === true ? (
              <div className="emptycart-div">
                <LazyLoadImage src={emptycartimg} alt=""></LazyLoadImage>
                <h5>{t("pages.Your shopping bag is empty")}</h5>
              </div>
            ) : (
              <>
                <section className="mobile-section">
                {cartlist.map((item, index) => (
                 <Card className="cart-mobile-list">
                  <Card.Img src={
                                item?.images === null
                                  ? product_default
                                  : item?.img_url
                              }  onError={(event) => {
                                event.target.src = product_default;
                              }}/>
                   <Card.Body>
                     <i className="mask_icon  delete_svg grey" onClick={() => removeProduct(item?.variation_id)} />
                       <div className="product-info">
                          <label>{props.language === "Tr"
                                ? item?.title_in_tr
                                : item?.product_name}</label>
                                  {item?.discount !== null &&
                          item?.discount !== 0 &&
                          item?.discount < item?.price ? (
                            <label>
                              {item?.discount}{" "}
                              {process.env.REACT_APP_CURRENCY_SYMBOL}
                            </label>
                          ) : (
                            <label>
                              {item?.price}{" "}
                              {process.env.REACT_APP_CURRENCY_SYMBOL}
                            </label>
                          )}
                           {quantityBox(item)}
                       </div>
                   </Card.Body>
                  </Card>
                ))}
                </section>

                <Row className="response-list-header">
                  <Col sm={12} md={4} lg={4} xl={4} className="ms-1">
                    <h5 className="row-header">
                      {t("pages.dashboard.product")}
                    </h5>
                  </Col>
                  <Col sm={12} md={2} lg={2} xl={2} className="text-left">
                    <h5 className="row-header">{t("pages.card.qty")}</h5>
                  </Col>
                  <Col sm={12} md={3} lg={3} xl={3} className="text-center">
                    <h5 className="row-header">{t("pages.card.price")}</h5>
                  </Col>
                  <Col sm={12} md={2} lg={2} xl={2}>
                    <h5 className="row-header">{t("pages.card.total")}</h5>
                  </Col>
                </Row>
                {cartlist.map((item, index) => (
                  <div className="response-list">
                    <Row className="align-items-center flex-nowrap">
                      <Col sm={12} md={4} lg={4} xl={4} className="ms-1">
                        <div className="item-box">
                          <h5 className="mobile-header">
                            {t("pages.dashboard.product")}
                          </h5>
                          <div className="product">
                            <div>
                            <LazyLoadImage
                              onError={(event) => {
                                event.target.src = product_default;
                              }}
                              src={
                                item?.images === null
                                  ? product_default
                                  : item?.img_url
                              }
                              alt=""
                            ></LazyLoadImage>  
                            </div>
                            <h5 className="ms-2">
                              {props.language === "Tr"
                                ? item?.title_in_tr
                                : item?.product_name}
                              <br />
                              {item?.product_qty}{" "}
                              {props.language === "Tr"
                                ? item?.unit_in_tr
                                : item?.unit_name}
                            </h5>
                          </div>
                        </div>
                      </Col>
                      <Col sm={12} md={2} lg={2} xl={2} className="ps-0">
                        <div className="qty-box">
                          <h5 className="mobile-header">
                            {t("pages.card.qty")}
                          </h5>
                          {quantityBox(item)}
                        </div>
                      </Col>
                      <Col
                        sm={12}
                        md={3}
                        lg={3}
                        xl={3}
                        className="align-items-center"
                      >
                        <div className="item-box product-price">
                          <h5 className="mobile-header">
                            {t("pages.card.price")}
                          </h5>
                          {item?.discount !== null &&
                          item?.discount !== 0 &&
                          item?.discount < item?.price ? (
                            <span>
                              {item?.discount}{" "}
                              {process.env.REACT_APP_CURRENCY_SYMBOL}
                            </span>
                          ) : (
                            <span>
                              {item?.price}{" "}
                              {process.env.REACT_APP_CURRENCY_SYMBOL}
                            </span>
                          )}
                        </div>
                      </Col>
                      <Col
                        sm={12}
                        md={2}
                        lg={2}
                        xl={2}
                        className="align-items-center"
                      >
                        <div className="item-box border-bottom-0">
                          <h5 className="mobile-header">
                            {t("pages.card.total")}
                          </h5>
                          {item?.discount !== null &&
                          item?.discount !== 0 &&
                          item?.discount < item?.price ? (
                            <span>
                              {item?.discount * item?.quantity}
                              {process.env.REACT_APP_CURRENCY_SYMBOL}
                            </span>
                          ) : (
                            <span>
                              {item?.price * item?.quantity}
                              {process.env.REACT_APP_CURRENCY_SYMBOL}
                            </span>
                          )}
                        </div>
                      </Col>
                      <Col sm={12} md={1} lg={1} xl={1}>
                        <button className="btn delete_icon_button" onClick={() => removeProduct(item?.variation_id)}>
                          <i className="mask_icon  delete_svg grey" />
                        </button>
                      </Col>
                    </Row>
                  </div>
                ))}
              </>
            )}
          </div>
          <div className="col-xl-3">
            <div className="order-card">
             <OrdersummaryPage amount={props?.amount}/>
              <div className="card value mt-3">
                <div className="card-body" onClick={() => openCouponpage()}>
                  <label
                    className="font-16"
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    {t("pages.checkout.Apply a coupan?")}{" "}
                    <span className="pr-color hover">
                      {t("pages.checkout.Click here")}
                    </span>
                  </label>
                </div>
              </div>
              <div className="mt-3">
              <ButtonPage Text={t("pages.payment_card.checkout")}  onClick={(e) => navigateTocheckout(e)} className={`button-submit w-100 rounded`} type={"submit"} /> 
              </div>
              <div>
                <button
                  className="btn-submit w-100 rounded pr mt-3"
                  onClick={() => navigate("/")}
                >
                  <img
                    src={arrowback}
                    height="25"
                    width="35"
                    className="pr-4"
                    alt="back"
                  />
                  {t("pages.payment_card.continue_shopping")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showcoupon && (
        <CoupanPage showcoupon={showcoupon} setShowcoupon={setShowcoupon} />
      )}
      {showdelivery && (
        <SelectdeliveryPage
          showdelivery={showdelivery}
          setShowdelivery={setShowdelivery}
          storelocation={storelocation}
        />
      )}
    </aside>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login?.access_token,
  cartdata: state?.home?.cartdata,
  amount: state?.home?.amount,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, {
  maintainCartdata,
  fetchHeaderContent,
})(ShoppingcardPage);
